import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { DirectivesModule } from '../../../projects/kiene-core/src/lib/directives/directives.module';
import { ArticleScanAutocompleteModule } from '../components/article-scan-autocomplete/article-scan-autocomplete.module';
import { KieneClientAutocompleteModule } from '../components/client-autocomplete/client-autocomlete.module';
import { ComponentsModule } from '../components/components.module';
import { DeleteButtonModule } from '../components/delete-button/delete-button.module';
import { KieneAutocompleteModule } from '../components/kiene-autocomplete/kiene-autocomplete.module';
import { KieneTableModule } from '../components/kiene-table/kiene-table.module';
import { TabinfoModule } from '../components/tabinfo/tabinfo.module';
import { KieneDirectivesModule } from '../directives/kiene-directives.module';
import { AnwendungsSelectorModule } from '../components/anwendungs-selector/anwendungs-selector.module';
import { DiagnoseSelectorModule } from '../components/diagnose-selector/diagnose-selector.module';
import { TierartSelectorModule } from '../components/tierart-selector/tierart-selector.module';
import { DialogsModule } from '../dialogs/dialogs.module';
import { WarehouseModule } from '../warehouse/warehouse.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { UnterschriftenModule } from '../../../projects/kiene-core/src/lib/components/unterschriften/unterschriften.module';
import { AntibiogrammDetailsComponent } from './antibiogramm/antibiogramm-details/antibiogramm-details.component';

import { AntibiogrammComponent, DownloadAllAntibiogrammeDialog } from './antibiogramm/antibiogramm.component';
import { AntibiogrammService } from './antibiogramm/antibiogramm.service';
import {
    BefundmitteilungComponent,
    BefundmitteilungNewNoteDialog,
    BefundmitteilungNewSampleSheetDialog,
    DownloadAllBefundmitteilungDialog,
    DownloadFileInfoDialog,
} from './befundmitteilung/befundmitteilung.component';
import { BefundmitteilungService } from './befundmitteilung/befundmitteilung.service';
import { DetailsseiteComponent } from './befundmitteilung/detailsseite/detailsseite.component';
import { ExterneBefundeDialogComponent } from './befundmitteilung/detailsseite/externe-befunde-dialog/externe-befunde-dialog.component';
import { IdexxResultDialogComponent } from './befundmitteilung/idexx-result-dialog/idexx-result-dialog.component';
import { MaterialienFilterDialogComponent } from './befundmitteilung/materialien-filter-dialog/materialien-filter-dialog.component';
import { PreisAnpassungDialogComponent } from './befundmitteilung/preis-anpassung-dialog/preis-anpassung-dialog.component';
import { BehandlungsArtikelComponent } from './behandlungs-artikel/behandlungs-artikel.component';
import { AddBehandlungsartikelDialogComponent } from './behandlungs-artikel/add-behandlungsartikel-dialog/add-behandlungsartikel-dialog.component';
import { BestellPdfVorschauDialogModule } from './behandlungs-artikel/add-behandlungsartikel-dialog/bestell-pdf-vorschau-dialog.module';

import { LaboratoryRoutingModule } from './laboratory-routing.module';
import { LaboratoryComponent } from './laboratory.component';
import { LaborDialogComponent } from './labore/labor-dialog/labor-dialog.component';
import { LaboreComponent } from './labore/labore.component';
import { AddProbenbegleitscheinPositionDialogComponent } from './probenbegleitschein/add-probenbegleitschein-position-dialog/add-probenbegleitschein-position-dialog.component';
import {
    UntersuchungTreeComponent,
    UntersuchungTreeDatabase,
} from './probenbegleitschein/add-probenbegleitschein-position-dialog/untersuchung-tree/untersuchung-tree.component';
import { AnzahlProbenDialogComponent } from './probenbegleitschein/anzahl-proben-dialog/anzahl-proben-dialog.component';
import { ProbenbegleitscheinDetailsComponent } from './probenbegleitschein/probenbegleitschein-details/probenbegleitschein-details.component';
import { ProbenbegleitscheinComponent } from './probenbegleitschein/probenbegleitschein.component';
import {
    AddTextkuerzelDialog,
    EditTextkuerzelDialog,
    TextAutocompleteComponent,
} from './text-autocomplete/text-autocomplete.component';
import { UntersuchungsauftragDetailsComponent } from './untersuchungsauftrag/untersuchungsauftrag-details/untersuchungsauftrag-details.component';
import { UntersuchungsauftragComponent } from './untersuchungsauftrag/untersuchungsauftrag.component';
import { UntersuchungsgruppeDialogComponent } from './untersuchungsgruppe/untersuchungsgruppe-dialog/untersuchungsgruppe-dialog.component';
import { UntersuchungsgruppeComponent } from './untersuchungsgruppe/untersuchungsgruppe.component';
import { AddUntersuchungsmaterialDialogComponent } from './untersuchungsmaterialien/add-untersuchungsmaterial-dialog/add-untersuchungsmaterial-dialog.component';
import { UntersuchungsmaterialKonfiguratorDialogComponent } from './untersuchungsmaterialien/untersuchungsmaterial-konfigurator-dialog/untersuchungsmaterial-konfigurator-dialog.component';
import { EditUntersuchungsmaterialDialogComponent } from './untersuchungsmaterialien/untersuchungsmaterial-konfigurator/edit-untersuchungsmaterial-dialog/edit-untersuchungsmaterial-dialog.component';
import {
    ArtikelstrukturDatabase,
    UntersuchungsmaterialKonfiguratorComponent,
} from './untersuchungsmaterialien/untersuchungsmaterial-konfigurator/untersuchungsmaterial-konfigurator.component';
import { UntersuchungsmaterialienComponent } from './untersuchungsmaterialien/untersuchungsmaterialien.component';
import { SelectBefundKategorieDialogComponent } from './befundmitteilung/select-befund-kategorie-dialog/select-befund-kategorie-dialog.component';
import { UntersuchungsauftragTransformDialogComponent } from './untersuchungsauftrag/untersuchungsauftrag-transform-dialog/untersuchungsauftrag-transform-dialog.component';

@NgModule({
    declarations: [
        LaboratoryComponent,
        AntibiogrammComponent,
        AntibiogrammDetailsComponent,
        BefundmitteilungComponent,
        BehandlungsArtikelComponent,
        AddBehandlungsartikelDialogComponent,
        LaboreComponent,
        LaborDialogComponent,
        ProbenbegleitscheinComponent,
        AddProbenbegleitscheinPositionDialogComponent,
        ProbenbegleitscheinDetailsComponent,
        TextAutocompleteComponent,
        UntersuchungsauftragComponent,
        UntersuchungsauftragDetailsComponent,
        UntersuchungsauftragTransformDialogComponent,
        UntersuchungsgruppeComponent,
        UntersuchungsgruppeDialogComponent,
        UntersuchungsmaterialienComponent,
        AddUntersuchungsmaterialDialogComponent,
        UntersuchungsmaterialKonfiguratorComponent,
        AddTextkuerzelDialog,
        EditTextkuerzelDialog,
        UntersuchungTreeComponent,
        DownloadAllAntibiogrammeDialog,
        DownloadAllBefundmitteilungDialog,
        DownloadFileInfoDialog,
        BefundmitteilungNewSampleSheetDialog,
        BefundmitteilungNewNoteDialog,
        DetailsseiteComponent,
        ExterneBefundeDialogComponent,
        IdexxResultDialogComponent,
        EditUntersuchungsmaterialDialogComponent,
        MaterialienFilterDialogComponent,
        UntersuchungsmaterialKonfiguratorDialogComponent,
        PreisAnpassungDialogComponent,
        EditUntersuchungsmaterialDialogComponent,
        MaterialienFilterDialogComponent,
        AnzahlProbenDialogComponent,
        SelectBefundKategorieDialogComponent,
    ],
    imports: [
        CommonModule,
        MatTabsModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDatepickerModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        MatIconModule,
        MatCardModule,
        MatMenuModule,
        MatChipsModule,
        MatToolbarModule,
        MatExpansionModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        MatDialogModule,
        MatPaginatorModule,
        MatRadioModule,
        MatDividerModule,
        MatBadgeModule,
        MatTreeModule,
        MatTableModule,
        MatListModule,
        KieneAutocompleteModule,
        KieneTableModule,
        LaboratoryRoutingModule,
        BestellPdfVorschauDialogModule,
        ArticleScanAutocompleteModule,
        DeleteButtonModule,
        DragDropModule,
        TabinfoModule,
        ComponentsModule,
        MatStepperModule,
        KieneClientAutocompleteModule,
        MatProgressBarModule,
        MatAutocompleteModule,
        MatTooltipModule,
        MatExpansionModule,
        KieneDirectivesModule,
        DirectivesModule,
        ArticleScanAutocompleteModule,
        TierartSelectorModule,
        AnwendungsSelectorModule,
        DiagnoseSelectorModule,
        DialogsModule,
        WarehouseModule,
        PdfViewerModule,
        UnterschriftenModule,
    ],

    providers: [AntibiogrammService, BefundmitteilungService, UntersuchungTreeDatabase, ArtikelstrukturDatabase],

    exports: [
        ProbenbegleitscheinComponent,
        BefundmitteilungComponent,
        AntibiogrammComponent,
        SelectBefundKategorieDialogComponent,
    ],
})
export class LaboratoryModule {}
